export default __webpack_public_path__ + "static/media/rb.ed69eeec.png";